const MIN_RANGE = 0.1;

export const LEFT_GEAR = 'left';
export const RIGHT_GEAR = 'right';

const getValueInRange = ({ pos, min = 0, max, stopPoint, gear }) => {
  if (gear === LEFT_GEAR && pos > stopPoint - MIN_RANGE) {
    return stopPoint - MIN_RANGE;
  }

  if (gear === RIGHT_GEAR && max - pos < stopPoint + MIN_RANGE)
    return max - stopPoint - MIN_RANGE;

  if (pos < min) return min;
  if (pos > max) return max;

  return pos;
};

export const getLeftValue = (pos, width, rightPos) =>
  getValueInRange({
    pos,
    min: 0,
    max: width,
    gear: LEFT_GEAR,
    stopPoint: width - rightPos,
  });

export const getRightValue = (pos, width, leftPos) =>
  getValueInRange({
    pos,
    min: 0,
    max: width,
    gear: RIGHT_GEAR,
    stopPoint: leftPos,
  });

export const interpolate = (
  value,
  rangeMin,
  rangeMax,
  targetMin,
  targetMax,
) => {
  const targetLength = targetMax - targetMin;
  const rangeLength = rangeMax - rangeMin;
  const stepSize = rangeLength / targetLength;
  const numberOfSteps = Math.round((value - rangeMin) / stepSize);
  return targetMin + numberOfSteps;
};

export const getRoundedValue = (value, step) => Math.round(value / step) * step;
